import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./my-classes.css";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import { FiClock } from "react-icons/fi";
import { MdEdit, MdDelete } from "react-icons/md";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useNavigate } from "react-router-dom";
const MyClasses = () => {
  const navigate = useNavigate();
  const [calendarValue, setCalendarValue] = React.useState(new Date());
  const [selectedEvent, setSelectedEvent] = React.useState(0);
  const LiveClassCard = [
    {
      name: "David anderson",
    },
    {
      name: "David anderson",
    },
    {
      name: "David anderson",
    },
  ];
  const EventList = [
    {
      title: "English Class",
      subTitle: "3rd Lesson",
      time: "18:00 - 19:30",
    },
    {
      title: "Maths Class",
      subTitle: "1st Lesson",
      time: "11:00 - 12:30",
    },
    {
      title: "Maths Class",
      subTitle: "2nd Lesson",
      time: "01:00 - 02:30",
    },
    {
      title: "Science",
      subTitle: "1st Lesson",
      time: "03:00 - 05:30",
    },
    {
      title: "English Class",
      subTitle: "2nd Lesson",
      time: "06:00 - 07:30",
    },
  ];
  return (
    <SideMenu>
      <div className="my-classes-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div>
                <p className="my-classes-heading">Upcomming</p>
                {LiveClassCard.map((liveClassValue, liveClassIndex) => {
                  return (
                    <div
                      className="live-classes-card"
                      key={liveClassIndex}
                      onClick={() => navigate("/my-classes/view")}
                    >
                      <p className="live-classes-card-heading">instructor</p>
                      <div className="live-classes-card-profile-main">
                        <img
                          src={ProfileImg}
                          className="live-classes-card-profile-image"
                        />
                        <p className="live-classes-card-username">
                          {liveClassValue.name}
                        </p>
                        <div className="live-button-main">
                          <p className="live-button-title">live</p>
                        </div>
                      </div>
                      <p className="live-classes-card-subject">Subject</p>
                      <p className="live-classes-card-subject-title">
                        English lecture
                      </p>
                      <p className="live-classes-card-description">
                        Integer sed lectus et sem porttitor vulputate. Integer a
                        felis est. Fusce sodales mollis risus...
                      </p>
                      <Button
                        className="live-classes-timing-button"
                        variant="text"
                        onClick={() => navigate("/my-classes/view")}
                      >
                        <FiClock color="#303030" />
                        <p className="live-classes-timing-button-text">
                          JAN 31, 2022, 10:30 AM
                        </p>
                      </Button>
                    </div>
                  );
                })}
              </div>
            </Grid>
            <Grid item xl={8} lg={8} md={8} sm={21} xs={12}>
              <div className="my-classes-second-section">
                <div className="page-header-button-main">
                  <Button
                    className="page-header-button"
                    variant="text"
                    onClick={() => navigate("/my-classes/create")}
                  >
                    <p className="page-header-button-text">Add class</p>
                  </Button>
                </div>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xl={3} lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="header-input-heading">
                          Search by course Name
                        </p>
                        <input
                          type="text"
                          className="header-input"
                          placeholder="Search by course Name"
                        />
                      </div>
                    </Grid>
                    <Grid item xl={7} lg={10} md={10} sm={10} xs={12}>
                      <DateRangePicker />
                    </Grid>
                    <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
                      <Button className="header-apply-button" variant="text">
                        <p className="header-apply-button-text">Apply</p>
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                <div>
                  <Calendar onChange={setCalendarValue} value={calendarValue} />
                </div>
                {EventList.map((eventValue, eventIndex) => {
                  return (
                    <div className="my-classes-card-main">
                      <p className="my-classes-card-time">08:00</p>
                      <div className="my-classes-card-line">- - -</div>
                      <Button
                        className={
                          selectedEvent === eventIndex
                            ? "my-classes-selected-card"
                            : "my-classes-un-selected-card"
                        }
                        variant="text"
                        key={eventIndex}
                        onClick={() => setSelectedEvent(eventIndex)}
                      >
                        <div className="upcomming-class-card-list-main">
                          <p
                            className={
                              selectedEvent === eventIndex
                                ? "upcomming-class-selected-card-title"
                                : "upcomming-class-un-selected-card-title"
                            }
                          >
                            {eventValue.title}
                          </p>
                          <p
                            className={
                              selectedEvent === eventIndex
                                ? "upcomming-class-selected-card-sub-title"
                                : "upcomming-class-un-selected-card-sub-title"
                            }
                          >
                            {eventValue.subTitle}
                          </p>
                        </div>
                        <p
                          className={
                            selectedEvent === eventIndex
                              ? "upcomming-class-selected-card-time"
                              : "upcomming-class-un-selected-card-time"
                          }
                        >
                          {eventValue.time}
                        </p>
                      </Button>
                      <div className="my-classes-card-edit-main">
                        <Button className="my-classes-card-button">
                          <MdEdit color="#000000" />
                        </Button>
                        <Button className="my-classes-card-button">
                          <MdDelete color="#000000" />
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default MyClasses;
